var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#029C54;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,16H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h12c1.1,0,2,0.9,2,2v12C16,15.1,15.1,16,14,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.4,4H4.6C4.3,4,4,4.3,4,4.6l0,0v6.8C4,11.7,4.3,12,4.6,12h6.8c0.3,0,0.6-0.3,0.6-0.6V4.6 C12,4.3,11.7,4,11.4,4z M7.2,10.5L4.8,8.1l1-1l1.4,1.4l3-3l1,1L7.2,10.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/TaskIcon.856929349fff6411b00c54be2faf5310.svg";
export { ForwardRef as ReactComponent };